import React from 'react';
import { useSelector } from 'react-redux';

import { TabNames } from '../../../../../../../../../../constants/tabMenuTypes';
import RequirementTemplateBlueprintType from '../../../../../../../../../../types/RequirementTemplateBlueprintType';
import LoadingSpinner from '../../../../../../../../../Spinner';
import TrayHeader from '../../../../../../../../../Tray/TrayHeader';

import CreateCustomPolicyTypeForm from './CreateCustomPolicyTypeForm';

const CreateCustomPolicyTypeTray = ({ blueprint }) => {
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Policies));
  const currentEditCustomPolicyId = useSelector(blueprint.selectCurrentEditCustomPolicyId);

  const titles = { 0: currentEditCustomPolicyId ? 'Edit Custom Policy' : 'Create Custom Policy' };

  const renderContent = () => {
    if (activeStep === 0) return <CreateCustomPolicyTypeForm blueprint={blueprint} />;
    return <LoadingSpinner />;
  };

  return (
    <>
      <TrayHeader title={titles[activeStep]} />
      {renderContent()}
    </>
  );
};

CreateCustomPolicyTypeTray.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default CreateCustomPolicyTypeTray;
